import { render, staticRenderFns } from "./Gubernamental.vue?vue&type=template&id=25d5f174&"
import script from "./Gubernamental.vue?vue&type=script&lang=js&"
export * from "./Gubernamental.vue?vue&type=script&lang=js&"
import style0 from "./Gubernamental.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports